// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { IProps, Text } from "@blueprintjs/core";

import { Classes, MPDIcon } from 'src/mpd-library';

import { StyledButton } from 'src/components';

import "./styles.css";

export interface ISettingsSocialBanterProps extends IProps {
  active?: boolean;
  imageName?: string;
  title?: string;
  subtitle?: string;
  actionButtonText?: string;
  actionButtonTextActive?: string;
  actionButtonClick?:(event: any) => void;
}

export const SettingsSocialBanter: React.SFC<ISettingsSocialBanterProps> = props => {
    const { className, active, title, subtitle, actionButtonClick, actionButtonText, actionButtonTextActive, imageName } = props;
    const classes = 'settings-social-banter'
    return (
      <div className={classNames(classes + '-container', className)}>
        <MPDIcon name={imageName} />
        <div className={classes + '-description'}>
            <Text className={classes + '-title'}> {title} </Text>
            <Text className={classes + '-sub-title'}> {subtitle} </Text>
        </div>
        <StyledButton
            className={classNames(classes + '-action', active && Classes.ACTIVE)}
            type={'default-blue'}
            text={active ? actionButtonTextActive : actionButtonText} 
            onClick={actionButtonClick}
        />
      </div>
    );
}

export default SettingsSocialBanter;



// WEBPACK FOOTER //
// ./src/controllers/alert-settings/components/settings-social-banter/settings-social-banter.tsx